/**
 * Custom Fit Configurator - Surcharge Product Approach
 * Uses separate price element to avoid Alpine.js conflicts.
 * Reloads page then opens cart drawer after custom fit add.
 */

(function() {
  'use strict';

  const configuratorEl = document.querySelector('[data-configurator]');

  const CONFIG = configuratorEl ? {
    mode: configuratorEl.dataset.setMode === 'true' ? 'set' : (configuratorEl.dataset.mode || 'iron'),
    pricePerClub: parseInt(configuratorEl.dataset.pricePerClub || '0', 10),
    clubVariants: JSON.parse(configuratorEl.dataset.clubVariants || '{}'),
    shaftSurchargeVariants: JSON.parse(configuratorEl.dataset.shaftSurchargeVariants || '{}'),
    gripSurchargeVariants: JSON.parse(configuratorEl.dataset.gripSurchargeVariants || '{}'),
    driverVariantId: configuratorEl.dataset.driverVariantId || '',
    currencySymbol: '£',
    productName: configuratorEl.dataset.productName || '',
    defaultFlexOptions: ['Regular', 'Stiff', 'Extra Stiff', 'Ladies', 'Seniors', '5.0', '5.5', '6.0', '6.5']
  } : null;

  const isDriverMode = CONFIG && CONFIG.mode === 'driver';
  const isSetMode = CONFIG && CONFIG.mode === 'set';
  let isCustomTab = false;

  const state = {
    selectedClubs: new Set(),
    selectedShaft: null,
    selectedGrip: null,
    selectedSetVariantId: null,
    selectedSetPrice: 0,
    selectedSetClubCount: 0
  };

  function getDirectText(el) {
    var s = '';
    for (var i = 0; i < el.childNodes.length; i++) {
      if (el.childNodes[i].nodeType === 3) s += el.childNodes[i].textContent;
    }
    return s.trim();
  }

  var ALLOWED_CART_LABELS = [
    'Fit Type', 'Shaft', 'Grip', 'Dexterity',
    'Flex', 'Length', 'Lie', 'Loft', 'Layers of Tape', 'Product'
  ];

  function hideCustomFitVariantTitles() {
    var lineItems = document.querySelectorAll(
      '[data-cart-item-line], [class*="cart-item__wrapper"], [class*="cart-drawer__item"], [class*="line-item__"], [class*="mini-cart__item"]'
    );
    lineItems.forEach(function(item) {
      if (item.dataset.customFitProcessed === 'true') return;
      var text = item.textContent || '';
      if (text.indexOf('Fit Type') === -1 || text.indexOf('Custom Fit') === -1) return;
      item.querySelectorAll('*').forEach(function(el) {
        if (el === item) return;
        if (el.closest('[data-hidden-by-custom-fit]')) return;
        var tag = el.tagName.toLowerCase();
        if (tag.match(/^(h1|h2|h3|h4|h5|h6|button|svg|path|img|input|select|textarea)$/)) return;
        if (el.closest('h1, h2, h3, h4, button')) return;
        var direct = getDirectText(el);
        if (!direct || direct.length === 0 || direct.length > 200) return;
        if (direct.indexOf(' / ') === -1) return;
        var row = el.closest(
          '[class*="config-group-"]:not([class*="config-group-remove"]), ' +
          '[class*="cart-drawer-item__property"], dl, li, [class*="meta"], p'
        );
        if (!row || row === item || row.contains(item)) {
          row = el.parentElement && el.parentElement !== item ? el.parentElement : el;
        }
        row.style.display = 'none';
        row.dataset.hiddenByCustomFit = 'true';
      });
      item.dataset.customFitProcessed = 'true';
    });
  }

  function initCartDrawerHooks() {
    hideCustomFitVariantTitles();
    var debounceTimer = null;
    var observer = new MutationObserver(function(mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        if (m.addedNodes.length === 0) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          var cls = (n.className && n.className.toString && n.className.toString()) || '';
          if (cls.indexOf('cart') > -1 || cls.indexOf('item') > -1 || cls.indexOf('line') > -1) {
            relevant = true; break;
          }
          if (n.querySelector && n.querySelector('[class*="cart"]')) {
            relevant = true; break;
          }
        }
        if (relevant) break;
      }
      if (!relevant) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        document.querySelectorAll('[data-custom-fit-processed]').forEach(function(el) {
          if (!el.querySelector('[data-hidden-by-custom-fit]')) {
            delete el.dataset.customFitProcessed;
          }
        });
        hideCustomFitVariantTitles();
      }, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerHooks);
  } else {
    initCartDrawerHooks();
  }

  if (!configuratorEl) return;

  function parseClubCount(label) {
    var m = label.match(/\((\d+)\s/);
    return m ? parseInt(m[1], 10) : 1;
  }

  function effectiveClubCount() {
    if (isDriverMode) return 1;
    if (isSetMode) return state.selectedSetClubCount;
    return state.selectedClubs.size;
  }

  function calculateTotal() {
    const clubCount = effectiveClubCount();
    const clubTotal = isSetMode ? state.selectedSetPrice : clubCount * CONFIG.pricePerClub;
    let shaftTotal = 0;
    if (state.selectedShaft && state.selectedShaft.pricePence > 0) {
      shaftTotal = state.selectedShaft.pricePence * clubCount;
    }
    let gripTotal = 0;
    if (state.selectedGrip && state.selectedGrip.pricePence > 0) {
      gripTotal = state.selectedGrip.pricePence * clubCount;
    }
    return { clubCount, clubTotal, shaftTotal, gripTotal, grandTotal: clubTotal + shaftTotal + gripTotal };
  }

  function formatMoney(pence) {
    return (pence / 100).toFixed(2);
  }

  function updateMainPrice(pence) {
    var customPrice = document.getElementById('configurator-custom-price');
    if (!customPrice) {
      var priceWrapper = document.querySelector('.product-info__price-wrapper');
      if (!priceWrapper) return;
      customPrice = document.createElement('div');
      customPrice.id = 'configurator-custom-price';
      customPrice.className = 'product-info__price-wrapper anm-fade-element mb-2 md:mb-2.5 is-visible';
      customPrice.innerHTML = '<div><div><p class="h3 price-wrapper h2"><span class="main-price">' + CONFIG.currencySymbol + '0.00</span></p></div></div>';
      priceWrapper.parentNode.insertBefore(customPrice, priceWrapper.nextSibling);
    }
    customPrice.style.display = '';
    customPrice.querySelector('.main-price').textContent = CONFIG.currencySymbol + formatMoney(pence);
  }

  function restoreMainPrice() {
    var customPrice = document.getElementById('configurator-custom-price');
    if (customPrice) customPrice.style.display = 'none';
  }

function updatePriceDisplay() {
  const totals = calculateTotal();
  const clubCountEl = document.querySelector('[data-club-count]');
  const shaftPriceEl = document.querySelector('[data-shaft-price]');
  const gripPriceEl = document.querySelector('[data-grip-price]');
  const totalPriceEl = document.querySelector('[data-total-price]');
  if (clubCountEl) clubCountEl.textContent = totals.clubCount;
  if (shaftPriceEl) shaftPriceEl.textContent = formatMoney(totals.shaftTotal);
  if (gripPriceEl) gripPriceEl.textContent = formatMoney(totals.gripTotal);
  if (totalPriceEl) totalPriceEl.textContent = formatMoney(totals.grandTotal);
  if (isSetMode) {
    var pricePerClubEl = configuratorEl.querySelector('[data-price-per-club]');
    if (pricePerClubEl) {
      pricePerClubEl.textContent = totals.clubTotal > 0
        ? CONFIG.currencySymbol + formatMoney(totals.clubTotal)
        : 'Select a set';
    }
  }
  if (isCustomTab) {
    updateMainPrice(totals.grandTotal);
  }
  const addBtn = document.querySelector('[data-custom-fit-add]');
  if (addBtn) {
    if (isDriverMode) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Basket — ' + CONFIG.currencySymbol + formatMoney(totals.grandTotal);
    } else if (isSetMode) {
      addBtn.disabled = !state.selectedSetVariantId;
      if (state.selectedSetVariantId) {
        addBtn.textContent = 'Add to Basket — ' + CONFIG.currencySymbol + formatMoney(totals.grandTotal);
      } else {
        addBtn.textContent = 'Select a Set to Continue';
      }
    } else {
      addBtn.disabled = totals.clubCount === 0;
      if (totals.clubCount > 0) {
        addBtn.textContent = 'Add to Basket — ' + CONFIG.currencySymbol + formatMoney(totals.grandTotal);
      } else {
        addBtn.textContent = 'Select Clubs to Continue';
      }
    }
  }
}

  function initClubSelection() {
    if (isDriverMode || isSetMode) return;
    document.querySelectorAll('[data-club-checkbox]').forEach(function(cb) {
      if (cb.checked) {
        state.selectedClubs.add(cb.value);
      }
      cb.addEventListener('change', function() {
        if (this.checked) {
          state.selectedClubs.add(this.value);
        } else {
          state.selectedClubs.delete(this.value);
        }
        updatePriceDisplay();
      });
    });
  }

  function initSetSelection() {
    if (!isSetMode) return;
    var setSelect = document.querySelector('[data-set-select]');
    if (!setSelect) return;
    setSelect.addEventListener('change', function() {
      var opt = this.options[this.selectedIndex];
      if (!opt) return;
      state.selectedSetVariantId = opt.dataset.variantId || null;
      state.selectedSetPrice = parseInt(opt.dataset.setPrice || '0', 10);
      state.selectedSetClubCount = parseClubCount(opt.value);
      updatePriceDisplay();
    });
  }

  function getSelectedOptionData(selectEl) {
    if (!selectEl) return null;
    var opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return null;
    return {
      name: opt.dataset.optionName || opt.value,
      pricePence: parseInt(opt.dataset.pricePence || '0', 10)
    };
  }

  function initOptionSelection() {
    var shaftSelect = document.querySelector('[data-shaft-option]');
    if (shaftSelect) {
      state.selectedShaft = getSelectedOptionData(shaftSelect);
      shaftSelect.addEventListener('change', function() {
        state.selectedShaft = getSelectedOptionData(this);
        updateDependentDropdown(this, '[data-custom-flex]', 'flexOptions');
        updatePriceDisplay();
      });
    }
    var gripSelect = document.querySelector('[data-grip-option]');
    if (gripSelect) {
      state.selectedGrip = getSelectedOptionData(gripSelect);
      gripSelect.addEventListener('change', function() {
        state.selectedGrip = getSelectedOptionData(this);
        updatePriceDisplay();
      });
    }
  }

  function updateDependentDropdown(parentSelect, childSelector, dataKey) {
    var childSelect = document.querySelector(childSelector);
    if (!childSelect) return;
    var selectedOpt = parentSelect.options[parentSelect.selectedIndex];
    if (!selectedOpt) return;
    var rawData = selectedOpt.dataset.flexOptions || '[]';
    var options = [];
    try {
      options = JSON.parse(rawData);
    } catch (e) {
      console.error('Failed to parse flex options:', rawData, e);
      options = [];
    }
    if (!options || options.length === 0) {
      options = CONFIG.defaultFlexOptions;
    }
    childSelect.innerHTML = '';
    var defaultOpt = document.createElement('option');
    defaultOpt.value = '';
    defaultOpt.textContent = 'Select...';
    defaultOpt.disabled = true;
    defaultOpt.selected = true;
    defaultOpt.hidden = true;
    childSelect.appendChild(defaultOpt);
    options.forEach(function(optionText) {
      var opt = document.createElement('option');
      opt.value = optionText;
      opt.textContent = optionText;
      childSelect.appendChild(opt);
    });
    childSelect.value = '';
    childSelect.disabled = false;
    rebuildCustomDropdown(childSelect);
  }

  function rebuildCustomDropdown(select) {
    var field = select.closest('.config-field');
    if (!field) return;
    var existingDD = field.querySelector('.custom-dropdown');
    if (existingDD) existingDD.remove();
    select.classList.remove('custom-dropdown-hidden');
    buildSingleCustomDropdown(select);
  }

  function findSurchargeVariantId(pricePence, variantMap) {
    if (pricePence <= 0 || !variantMap || Object.keys(variantMap).length === 0) return null;
    if (variantMap[pricePence.toString()]) return variantMap[pricePence.toString()];
    var availablePrices = Object.keys(variantMap).map(Number).sort(function(a, b) { return a - b; });
    for (var i = 0; i < availablePrices.length; i++) {
      if (availablePrices[i] >= pricePence) return variantMap[availablePrices[i].toString()];
    }
    return variantMap[availablePrices[availablePrices.length - 1].toString()];
  }

  function generateConfigGroupId() {
    return 'cf_' + Date.now().toString(36) + '_' + Math.random().toString(36).substr(2, 5);
  }

  function collectAdditionalOptions() {
    var props = {};
    var dexterityEl = document.querySelector('[data-custom-dexterity]');
    if (dexterityEl) props['Dexterity'] = dexterityEl.value;
    var fields = [
      { selector: '[data-custom-flex]', label: 'Flex' },
      { selector: '[data-custom-length]', label: 'Length' },
      { selector: '[data-custom-lie]', label: 'Lie' },
      { selector: '[data-custom-loft]', label: 'Loft' },
      { selector: '[data-custom-grip-size]', label: 'Layers of Tape' }
    ];
    fields.forEach(function(field) {
      var el = document.querySelector(field.selector);
      if (el && el.value) props[field.label] = el.value;
    });
    return props;
  }

  function buildCartItems() {
    var items = [];
    var groupId = generateConfigGroupId();
    var shaftName = state.selectedShaft ? state.selectedShaft.name : 'Standard';
    var gripName = state.selectedGrip ? state.selectedGrip.name : 'Standard';
    var additionalProps = collectAdditionalOptions();
    var qty = effectiveClubCount();

    if (isDriverMode) {
      var variantId = CONFIG.driverVariantId;
      if (!variantId) { console.error('No driver variant ID configured'); return []; }
      var properties = {
        '_config_group': groupId, '_config_type': 'club',
        'Fit Type': 'Custom Fit', 'Shaft': shaftName, 'Grip': gripName
      };
      for (var key in additionalProps) { properties[key] = additionalProps[key]; }
      items.push({ id: parseInt(variantId, 10), quantity: 1, properties: properties });
    } else if (isSetMode) {
      if (!state.selectedSetVariantId) return [];
      var setSelect = document.querySelector('[data-set-select]');
      var setName = setSelect ? setSelect.value : '';
      var properties = {
        '_config_group': groupId, '_config_type': 'club',
        'Product': CONFIG.productName, 'Fit Type': 'Custom Fit',
        'Set': setName, 'Shaft': shaftName, 'Grip': gripName
      };
      for (var k in additionalProps) { properties[k] = additionalProps[k]; }
      items.push({ id: parseInt(state.selectedSetVariantId, 10), quantity: 1, properties: properties });
    } else {
      state.selectedClubs.forEach(function(clubName) {
        var variantId = CONFIG.clubVariants[clubName];
        if (!variantId) { console.error('No variant ID for club:', clubName); return; }
        var properties = {
          '_config_group': groupId, '_config_type': 'club',
          'Product': CONFIG.productName, 'Fit Type': 'Custom Fit',
          'Shaft': shaftName, 'Grip': gripName
        };
        for (var k in additionalProps) { properties[k] = additionalProps[k]; }
        items.push({ id: parseInt(variantId, 10), quantity: 1, properties: properties });
      });
    }

    if (state.selectedShaft && state.selectedShaft.pricePence > 0 && qty > 0) {
      var shaftVariantId = findSurchargeVariantId(state.selectedShaft.pricePence, CONFIG.shaftSurchargeVariants);
      if (shaftVariantId) {
        items.push({ id: parseInt(shaftVariantId, 10), quantity: qty,
          properties: { '_config_group': groupId, '_config_type': 'shaft_surcharge', '_surcharge_label': 'Shaft: ' + shaftName }
        });
      }
    }
    if (state.selectedGrip && state.selectedGrip.pricePence > 0 && qty > 0) {
      var gripVariantId = findSurchargeVariantId(state.selectedGrip.pricePence, CONFIG.gripSurchargeVariants);
      if (gripVariantId) {
        items.push({ id: parseInt(gripVariantId, 10), quantity: qty,
          properties: { '_config_group': groupId, '_config_type': 'grip_surcharge', '_surcharge_label': 'Grip: ' + gripName }
        });
      }
    }
    return items;
  }

  function addToCart() {
    var allFields = document.querySelectorAll('.config-field select');
    var incomplete = false;
    allFields.forEach(function(field) {
      var customDD = field.closest('.config-field').querySelector('.custom-dropdown');
      if (!field.value) { if (customDD) customDD.classList.add('is-invalid'); incomplete = true; }
      else { if (customDD) customDD.classList.remove('is-invalid'); }
    });
    if (incomplete) return;
    var items = buildCartItems();
    if (items.length === 0) return;
    var addBtn = document.querySelector('[data-custom-fit-add]');
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(err) { throw new Error(err.description || 'Failed'); });
      return response.json();
    })
    .then(function() {
      if (addBtn) { addBtn.textContent = '✓ Added to Basket!'; }
      sessionStorage.setItem('openCartDrawer', 'true');
      setTimeout(function() { window.location.reload(); }, 300);
    })
    .catch(function(error) {
      console.error('Add to cart error:', error);
      if (addBtn) { addBtn.textContent = 'Error — try again'; addBtn.disabled = false; }
    });
  }

  function triggerCartRefresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    window.dispatchEvent(new CustomEvent('cart:open'));
    if (typeof Alpine !== 'undefined') document.dispatchEvent(new CustomEvent('cart:updated'));
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span').forEach(function(el) {
        el.textContent = cart.item_count;
      });
    }).catch(function() {});
  }

  function initTabs() {
    var tabs = document.querySelectorAll('[data-tab]');
    var panels = document.querySelectorAll('[data-tab-panel]');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.dataset.tab;
        tabs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        panels.forEach(function(panel) {
          if (panel.dataset.tabPanel === target) { panel.style.display = ''; panel.classList.add('active'); }
          else { panel.style.display = 'none'; panel.classList.remove('active'); }
        });
        if (target === 'custom') {
          isCustomTab = true;
          document.body.classList.add('configurator-custom-active');
          document.querySelectorAll('.product-info__buy-buttons-wrapper, .product-info__variant-picker, .product-info__inventory-status-wrapper, .product-info__estimate-delivery-wrapper').forEach(function(el) { el.style.display = 'none'; });
          document.querySelectorAll('.product-info__text-with-icon_wrapper').forEach(function(el) {
            var text = el.textContent.toLowerCase();
            if (text.indexOf('in stock') > -1 || text.indexOf('dispatched within') > -1) { el.style.display = 'none'; el.dataset.hiddenByConfigurator = 'true'; }
          });
          updatePriceDisplay();
        } else {
          isCustomTab = false;
          document.body.classList.remove('configurator-custom-active');
          document.querySelectorAll('.product-info__buy-buttons-wrapper, .product-info__variant-picker, .product-info__inventory-status-wrapper').forEach(function(el) { el.style.display = ''; });
          restoreMainPrice();
        }
      });
    });
  }

  function initStandardAddToCart() {
    var standardBtn = document.querySelector('[data-add-standard]');
    if (!standardBtn) return;
    standardBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var selectedVariant = document.querySelector('input[name="variant-id"]:checked');
      if (!selectedVariant) return;
      var originalText = standardBtn.textContent;
      standardBtn.disabled = true; standardBtn.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(selectedVariant.value, 10), quantity: 1 }) })
      .then(function(r) { return r.json(); })
      .then(function() {
        standardBtn.textContent = '✓ Added to Cart!';
        setTimeout(function() { standardBtn.textContent = originalText; standardBtn.disabled = false; }, 2000);
        triggerCartRefresh();
      })
      .catch(function() {
        standardBtn.textContent = 'Error — try again'; standardBtn.disabled = false;
        setTimeout(function() { standardBtn.textContent = originalText; }, 3000);
      });
    });
  }

  function initProgressiveFields() {
    var fields = document.querySelectorAll('.config-field select');
    if (fields.length < 2) return;
    for (var i = 1; i < fields.length; i++) { fields[i].disabled = true; }
    fields.forEach(function(field, index) {
      field.addEventListener('change', function() {
        if (this.value && index + 1 < fields.length) { fields[index + 1].disabled = false; }
      });
    });
  }

  var arrowSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>';

  function buildSingleCustomDropdown(select) {
  var field = select.closest('.config-field');
  if (!field) return;
  var labelEl = field.querySelector('.config-label');
  var labelText = '';
  if (labelEl) { labelText = labelEl.textContent.trim(); field.dataset.configLabel = labelText; labelEl.remove(); }
  else { labelText = field.dataset.configLabel || ''; }
  var dropdown = document.createElement('div'); dropdown.className = 'custom-dropdown';
  if (select.disabled) dropdown.classList.add('is-disabled');
  var trigger = document.createElement('div'); trigger.className = 'custom-dropdown__trigger';
  var label = document.createElement('span'); label.className = 'custom-dropdown__label'; label.textContent = labelText;
  var value = document.createElement('span'); value.className = 'custom-dropdown__value';
  var arrow = document.createElement('span'); arrow.className = 'custom-dropdown__arrow'; arrow.innerHTML = arrowSVG;
  trigger.appendChild(label); trigger.appendChild(value); trigger.appendChild(arrow);
  var optionsPanel = document.createElement('div'); optionsPanel.className = 'custom-dropdown__options';
  Array.from(select.options).forEach(function(opt) {
    if (opt.disabled || opt.hidden || !opt.value) return;
    var optionDiv = document.createElement('div'); optionDiv.className = 'custom-dropdown__option'; optionDiv.dataset.value = opt.value;
    var optText = opt.textContent.trim();
    var priceMatch = optText.match(/(\(\+£[\d.]+\))/);
    if (priceMatch) {
      var nameSpan = document.createElement('span'); nameSpan.className = 'custom-dropdown__option-name';
      nameSpan.textContent = optText.replace(priceMatch[1], '').trim();
      var priceSpan = document.createElement('span'); priceSpan.className = 'custom-dropdown__option-price'; priceSpan.textContent = priceMatch[1];
      optionDiv.appendChild(nameSpan); optionDiv.appendChild(priceSpan);
    } else {
      var nameSpan = document.createElement('span'); nameSpan.className = 'custom-dropdown__option-name'; nameSpan.textContent = optText;
      optionDiv.appendChild(nameSpan);
    }
    if (opt.dataset.optionName) optionDiv.dataset.optionName = opt.dataset.optionName;
    if (opt.dataset.pricePence) optionDiv.dataset.pricePence = opt.dataset.pricePence;
    optionDiv.addEventListener('click', function(e) {
      e.stopPropagation();
      select.value = this.dataset.value;
      var event = new Event('change', { bubbles: true }); select.dispatchEvent(event);
      var displayName = this.querySelector('.custom-dropdown__option-name');
      var displayPrice = this.querySelector('.custom-dropdown__option-price');
      value.innerHTML = '';
      var valName = document.createElement('span');
      valName.className = 'custom-dropdown__value-name';
      valName.textContent = displayName ? displayName.textContent : this.textContent;
      value.appendChild(valName);
      if (displayPrice) {
        var valPrice = document.createElement('span');
        valPrice.className = 'custom-dropdown__value-price';
        valPrice.textContent = ' ' + displayPrice.textContent;
        value.appendChild(valPrice);
      }
      dropdown.classList.add('has-value'); dropdown.classList.remove('is-open', 'is-invalid');
      optionsPanel.querySelectorAll('.custom-dropdown__option').forEach(function(o) { o.classList.remove('is-selected'); });
      this.classList.add('is-selected');
    });
    optionsPanel.appendChild(optionDiv);
  });
  dropdown.appendChild(trigger); dropdown.appendChild(optionsPanel);
  select.classList.add('custom-dropdown-hidden'); field.appendChild(dropdown);
  trigger.addEventListener('click', function(e) {
    e.stopPropagation();
    document.querySelectorAll('.custom-dropdown.is-open').forEach(function(d) { if (d !== dropdown) d.classList.remove('is-open'); });
    dropdown.classList.toggle('is-open');
  });
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'disabled') {
        if (select.disabled) dropdown.classList.add('is-disabled');
        else dropdown.classList.remove('is-disabled');
      }
    });
  });
  observer.observe(select, { attributes: true });
}

  function initCustomDropdowns() {
    var selects = document.querySelectorAll('.config-field select');
    if (selects.length === 0) return;
    selects.forEach(function(select) { buildSingleCustomDropdown(select); });
    document.addEventListener('click', function() {
      document.querySelectorAll('.custom-dropdown.is-open').forEach(function(d) { d.classList.remove('is-open'); });
    });
  }

  function init() {
    initTabs();
    initClubSelection();
    initSetSelection();
    initOptionSelection();
    initProgressiveFields();
    initCustomDropdowns();
    initStandardAddToCart();

    var shaftSelect = document.querySelector('[data-shaft-option]');
    if (shaftSelect && shaftSelect.value) {
      updateDependentDropdown(shaftSelect, '[data-custom-flex]', 'flexOptions');
    }

    var addBtn = document.querySelector('[data-custom-fit-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function(e) { e.preventDefault(); addToCart(); });
    }

    var hasTabs = document.querySelectorAll('[data-tab]').length > 0;
    var customPanel = document.querySelector('[data-tab-panel="custom"]');
    if (hasTabs) {
      if (customPanel) customPanel.style.display = 'none';
    } else {
      isCustomTab = true;
      document.body.classList.add('configurator-custom-active');
      document.querySelectorAll('.product-info__buy-buttons-wrapper, .product-info__variant-picker, .product-info__inventory-status-wrapper, .product-info__estimate-delivery-wrapper').forEach(function(el) { el.style.display = 'none'; });
      document.querySelectorAll('.product-info__text-with-icon_wrapper').forEach(function(el) {
        var text = el.textContent.toLowerCase();
        if (text.indexOf('in stock') > -1 || text.indexOf('dispatched within') > -1) { el.style.display = 'none'; el.dataset.hiddenByConfigurator = 'true'; }
      });
      updatePriceDisplay();
    }

    if (sessionStorage.getItem('openCartDrawer') === 'true') {
      sessionStorage.removeItem('openCartDrawer');
      setTimeout(function() { if (typeof Alpine !== 'undefined') { Alpine.store('xMiniCart').handleOpen(); } }, 500);
    }

    updatePriceDisplay();
    console.log('Custom Fit Configurator initialised', CONFIG);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

})();
